export const mainColors = {
    green: '#5DAC47',
    red: '#F14732',
    grey: '#A0A09F',
    blue: '#55ACEE',
    yellow: '#F1C40F',
};
